// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import axios from "axios";
import Loading from "components/lib/loading";
import CenterContainer from "components/lib/center-container";
import popupButton from "components/lib/popupButton";
import uploadFile from "components/lib/uploadFile";
import uploadTemplateFile from "components/lib/uploadTemplateFile";
import hiddenSelectButton from "components/lib/hiddenSelectButton";
import YmapPlugin from "vue-yandex-maps";
import Clipboard from "v-clipboard";
import Multiselect from "vue-multiselect";
import DefaultLayout from "./layouts/Default";
import AdminLayout from "./layouts/Admin";

Vue.prototype.$http = axios;
const token = localStorage.getItem("user-token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

Vue.config.productionTip = false;

Vue.component("admin-layout", AdminLayout);
Vue.component("default-layout", DefaultLayout);
Vue.component("loading", Loading);
Vue.component("center-container", CenterContainer);
Vue.component("multiselect", Multiselect);
Vue.component("popup-button", popupButton);
Vue.component("upload-file", uploadFile);
Vue.component("upload-template-file", uploadTemplateFile);
Vue.component("hidden-select-button", hiddenSelectButton);

const settings = {
  apiKey: "bf014650-2cc4-46de-a6d4-034052108e2d",
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
  controls: ["smallMapDefaultSet"]
};
Vue.use(YmapPlugin, settings);
Vue.use(Clipboard);

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});
